import clg from "./log";

export const encodeNestedObjToQueryString = ( obj ) => {

    let qArr = [];

    Object.keys(obj).map(key => {

        const value = obj[key];

        if( Array.isArray(value) ) {
            qArr.push( `${key}=${ value.join(",") }` );
        }

        else if( typeof value === "object" ) {
            Object.keys( value ).map( oKey => {
                qArr.push( `${key}[${oKey}]=${value[oKey]}` );
            })
        }

        else {
            qArr.push( `${key}=${value}` );
        }
    });

    return "?" + encodeURIComponent( qArr.join("&") );
}

export const decodeQueryStringToNestedObj = ( qs ) => {

    if( !qs.length ) {
        return {}
    }

    const qsArr = decodeURIComponent(qs.replace("?", "")).split("&");

    const qsObj = { objects : {}, arrays : {}, strings : {} };

    qsArr.map( (value, index) => {
        
        const spValue = value.split("=");
        const vKey = spValue[0];
        const vValue = spValue[1];
        
        //Ha array volt encode előtt
        if( vValue.includes(",") ) {
            const vValueArr = vValue.split(",");

            let formatted = [];
            vValueArr.map( curr => {
                formatted.push(convertStringToDataType( curr ));
            })

            qsObj.arrays[vKey] = formatted;
        }

        //Ha object volt encode előtt
        if( vKey.includes("[") && vKey.includes("]") ) {
            const keyValueArr = value.split("=");
            const oVal = vValue;
            const oKey = keyValueArr[0].split("[")[1].replace("]", "");
            const oOuterKey = keyValueArr[0].split("[")[0];

            if( qsObj.objects.hasOwnProperty( oOuterKey ) ) {
            //Ha a qsObj-ben van már a jelenlegi kulcs
                qsObj.objects[oOuterKey] = {
                    ...qsObj.objects[oOuterKey],
                    [oKey] : convertStringToDataType( oVal ) 
                };
            } else {
            //Ha a qsObj-ben még nincs a jelenlegi kulcs
                qsObj.objects[oOuterKey] = { [oKey] : convertStringToDataType( oVal ) };
            }
            //clg("HAS BENN AN OBJ: ", index, value, keyValueArr, oKey, oOuterKey, { [oOuterKey] : { [oKey] : oVal } })
        }

        //Ha string volt encode előtt
        if( !vValue.includes(",") && !vKey.includes("[") && !vKey.includes("]") ) {
            qsObj.strings[vKey] = convertStringToDataType( vValue );
        }
    });

    function convertStringToDataType( string ) {
        //Ha szám
        if( !isNaN( string ) ) {
            return Number( string );
        }

        //Ha bool
        if( string === "true") {
            return true
        } else if ( string === "false" ) {
            return false;
        }

        return string
    }

    return {
        ...qsObj.arrays,
        ...qsObj.objects,
        ...qsObj.strings,
    }
}